export default __webpack_public_path__ + "static/Hailey-b0d36677d35ff05418adbb405e075dd0.png";